import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconSvgComponent, RxAlertModule } from '@roomex/rx-components';

import { TRANSLATION_SCOPE, translationProvider as translationProvider } from './assets/i18n/translation.provider';
import { Approver } from '@rx-applications/clientsite/shared/config/utils';
import { TranslocoDirective } from '@ngneat/transloco';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'rx-applications-approval-request-warning-message',
  standalone: true,
  imports: [CommonModule, RxAlertModule, IconSvgComponent, TranslocoDirective, NgbTooltipModule],
  templateUrl: './approval-request-warning-message.component.html',
  styleUrl: './approval-request-warning-message.component.scss',
  providers: [translationProvider],
})
export class ApprovalRequestWarningMessageComponent {
  readonly TRANSLATION_SCOPE = TRANSLATION_SCOPE;
  @Input({ transform: (value: Approver | Approver[]) => (Array.isArray(value) ? value : [{ username: value }]) })
  approvers: Approver[] = [];
  @Input() isOutOfPolicyRequest = false;

  createHeaderMessage(isOutOfPolicyRequest: boolean, approvers: Approver[]): string {
    if (isOutOfPolicyRequest) {
      return approvers.length > 1
        ? 'outOfPolicyBookingMultipleApproversWarningHeader'
        : 'outOfPolicyBookingSingleApproversWarningHeader';
    }
    return approvers.length > 1 ? 'bookingApprovalWarningHeader' : 'bookingApprovalSingleWarningHeader';
  }
}
